import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useGlobalStore } from "../context/UserContext/userContext";
import { completeCreMsalLogin } from "./completeCreMsalLogin";
import { getCreRedirectUri } from "./creAuthConfig";

export default function CreSessionHandler() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const result = await completeCreMsalLogin();
        if (cancelled) return;

        if (result.ok) {
          if (result.mode === "extension") {
            navigate(result.extensionPath, { replace: true });
          } else {
            navigate(result.patientPath, { replace: true });
          }
          return;
        }

        const messages = {
          no_account: "No signed-in account found.",
          no_token: "Could not obtain an access token.",
          validate_failed:
            "Your account could not be validated. Please contact your administrator.",
        };
        setError(messages[result.reason] || "Session validation failed");
      } catch (err) {
        console.error("CRE session error:", err);
        if (!cancelled) {
          setError(err?.message || "Session validation failed");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const handleSignInAgain = () => {
    useGlobalStore.getState().clear();
    instance.logoutRedirect({ postLogoutRedirectUri: getCreRedirectUri() });
  };

  if (error) {
    return (
      <div className="cre-root cre-session-page">
        <div className="cre-login-bg" aria-hidden />
        <div className="cre-session-card">
          <h2 className="cre-session-error-title">Unable to sign in</h2>
          <p className="cre-session-error-message">{error}</p>
          <button
            type="button"
            className="cre-btn-signin"
            onClick={handleSignInAgain}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cre-root cre-session-page">
      <div className="cre-login-bg" aria-hidden />
      <p className="cre-session-status">Preparing your workspace…</p>
    </div>
  );
}
